/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2023-02-24 01:27:15
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-02-25 10:32:53
 * @FilePath: /wemeet-web-lobby/src/app/[eventId]/LayoutContext.tsx
 * @Description: 给一个context好了
 */
'use client';

import React, { createContext } from 'react';
const defaultValue = {
  http: {},
  dataReport: (_name, _obj) => {}
};
export const ThemeContext = /*#__PURE__*/createContext(defaultValue);
export default function ThemeProvider({
  children,
  value
}) {
  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: value
  }, children);
}